import React from "react"
import { ContentCell, Flex } from "src/components/Grid"
import moment from "moment"
import get from "lodash/get"
import storage from "src/helpers/storage"
import Chips from "@infotech/uikit-chips"
import {
  USER_SCALES,
  CHIPS_SCALE_NAMES,
  SCALE_CODES,
  URL_DATE_FORMAT,
  LAST_SELECTED_DATES,
} from "../../constants"

export default function ScaleControl({
  calendarScale,
  start,
  queryApi: { push },
}) {
  const chipsOptions = USER_SCALES.map(scale => ({
    value: scale,
    label: CHIPS_SCALE_NAMES[scale],
  }))
  return (
    <Flex>
      <ContentCell>
        <div data-testid="calendar-scale-select">
          <Chips
            value={chipsOptions.find(option => calendarScale === option.value)}
            options={chipsOptions}
            onChange={({ target: { value } }) => {
              const scale = get(value, `[0].value`)
              if (scale === null) {
                return
              }
              const scaleName = SCALE_CODES[scale]
              const currentUrl = window.location.pathname
              const savedScaleDates = storage.get(LAST_SELECTED_DATES)
              const newDate =
                (savedScaleDates && savedScaleDates[scaleName]) ||
                moment(start)
                  .startOf(scaleName)
                  .format(URL_DATE_FORMAT)

              const newUrl = currentUrl.replace(
                /\/calendar\/?[^/]*\/?[^/]*/,
                `/calendar/${scaleName}/${newDate}`,
              )
              delete savedScaleDates[scaleName]
              storage.set(LAST_SELECTED_DATES, savedScaleDates)
              push(newUrl)
            }}
            radio
          />
        </div>
      </ContentCell>
    </Flex>
  )
}
